import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=551addae&scoped=true&"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js&"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=551addae&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../.config/yarn/global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551addae",
  null
  
)

export default component.exports